/**
 * The "Cars" filter of a BI dashboard (CU-869fmhmx8 E1, E4, E6, E7): one kind at a time — Acriss, Category or Acriss
 * Group — and its values. It acts before the load: the server filters, and turns a group into its codes with the
 * groups of the user's company only. In the view it is `cars` (`all` | `group` | `acriss` | `category`) and `carsIds`.
 *
 * Pure and alias-free: `node --test` runs it.
 */

import { menuTab, replaceNote, shortList } from '../../../../@components/KindPillsField/kindPills.js'
import { CARS, CARS_LABEL, DEFAULT_CARS_TAB, carsOn } from '../../../../@components/KindPillsField/carKinds.js'

// the car kinds live with the shared field (CU-869fmpqfm): the price analyzers' Cars selector uses them too
export { CARS, CARS_LABEL, CARS_KIND_ORDER, DEFAULT_CARS_TAB, NO_GROUPS_TEXT, GROUPS_HEADER, carsKinds } from '../../../../@components/KindPillsField/carKinds.js'
// the rules of the picked values too (CU-869fmpqfm v1.2): the price analyzers' Cars selector picks several as well
export { CARS_MAX_VALUES, NO_CARS, parseCars, carsOn, pickCars, carsLabels } from '../../../../@components/KindPillsField/carKinds.js'

// what the server calls each kind (`carsType`) and the key of the body that carries the values
export const CARS_TYPE = Object.freeze({ [CARS.GROUP]: 'acriss_group', [CARS.ACRISS]: 'acriss', [CARS.CATEGORY]: 'category' })
export const CARS_BODY_KEY = Object.freeze({ [CARS.GROUP]: 'acrissGroupID', [CARS.ACRISS]: 'acriss', [CARS.CATEGORY]: 'categoryID' })

export const ANY_CARS_TEXT = 'Any Acriss Group, Acriss or Category'

/** The pill the menu opens on: the kind in use, or Acriss */
export const carsMenuTab = view => menuTab({ kind: view?.cars, on: carsOn(view) }, DEFAULT_CARS_TAB)

/** `Economy, Compact` · `Economy, Compact +1` */
export { shortList }

/** The line under the field: what the filter means; for groups, their codes as the server resolved them */
export function carsUnder(view, resolved) {
	if (!carsOn(view)) return ANY_CARS_TEXT
	if (view.cars === CARS.GROUP) {
		const groups = resolved?.type === CARS_TYPE[CARS.GROUP] ? resolved.groups || [] : []
		return groups.length ? groups.map(g => `${g.name} = ${g.codes.join(', ')}`).join(' · ') : 'By Acriss Group'
	}
	return `By ${CARS_LABEL[view.cars]}`
}

/** Inside the menu, looking at another kind while one is in use */
export function carsReplaceNote(view, tab, labels) {
	return replaceNote({ kind: view?.cars, on: carsOn(view) }, tab, labels)
}

/** The body keys of `POST /results` (E1): one kind with its values, or nothing for all cars */
export function carsBody(view) {
	if (!carsOn(view)) return {}
	return { carsType: CARS_TYPE[view.cars], [CARS_BODY_KEY[view.cars]]: [...view.carsIds] }
}
